import { render, staticRenderFns } from "./apply-info.vue?vue&type=template&id=0f88f326&scoped=true&"
import script from "./apply-info.vue?vue&type=script&lang=js&"
export * from "./apply-info.vue?vue&type=script&lang=js&"
import style0 from "./apply-info.vue?vue&type=style&index=0&id=0f88f326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88f326",
  null
  
)

export default component.exports